/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateNewEmailOptionsCommand } from '../models';
// @ts-ignore
import { EmailOptionsDto } from '../models';
// @ts-ignore
import { TestSmtpConnectionCommand } from '../models';
// @ts-ignore
import { UpdateEmailOptionsCommand } from '../models';
/**
 * EmailOptionsApi - axios parameter creator
 * @export
 */
export const EmailOptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOptionsActiveGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-options/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOptionsGet: async (organizationId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['OrganizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateNewEmailOptionsCommand} [createNewEmailOptionsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOptionsPost: async (createNewEmailOptionsCommand?: CreateNewEmailOptionsCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNewEmailOptionsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateEmailOptionsCommand} [updateEmailOptionsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOptionsPut: async (updateEmailOptionsCommand?: UpdateEmailOptionsCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailOptionsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TestSmtpConnectionCommand} [testSmtpConnectionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOptionsTestConnectionPost: async (testSmtpConnectionCommand?: TestSmtpConnectionCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-options/test-connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testSmtpConnectionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailOptionsApi - functional programming interface
 * @export
 */
export const EmailOptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailOptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailOptionsActiveGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailOptionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailOptionsActiveGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailOptionsGet(organizationId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailOptionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailOptionsGet(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateNewEmailOptionsCommand} [createNewEmailOptionsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailOptionsPost(createNewEmailOptionsCommand?: CreateNewEmailOptionsCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailOptionsPost(createNewEmailOptionsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateEmailOptionsCommand} [updateEmailOptionsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailOptionsPut(updateEmailOptionsCommand?: UpdateEmailOptionsCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailOptionsPut(updateEmailOptionsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TestSmtpConnectionCommand} [testSmtpConnectionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailOptionsTestConnectionPost(testSmtpConnectionCommand?: TestSmtpConnectionCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailOptionsTestConnectionPost(testSmtpConnectionCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailOptionsApi - factory interface
 * @export
 */
export const EmailOptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailOptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOptionsActiveGet(options?: any): AxiosPromise<EmailOptionsDto> {
            return localVarFp.emailOptionsActiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOptionsGet(organizationId?: number, options?: any): AxiosPromise<EmailOptionsDto> {
            return localVarFp.emailOptionsGet(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateNewEmailOptionsCommand} [createNewEmailOptionsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOptionsPost(createNewEmailOptionsCommand?: CreateNewEmailOptionsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.emailOptionsPost(createNewEmailOptionsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateEmailOptionsCommand} [updateEmailOptionsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOptionsPut(updateEmailOptionsCommand?: UpdateEmailOptionsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.emailOptionsPut(updateEmailOptionsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TestSmtpConnectionCommand} [testSmtpConnectionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailOptionsTestConnectionPost(testSmtpConnectionCommand?: TestSmtpConnectionCommand, options?: any): AxiosPromise<void> {
            return localVarFp.emailOptionsTestConnectionPost(testSmtpConnectionCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for emailOptionsGet operation in EmailOptionsApi.
 * @export
 * @interface EmailOptionsApiEmailOptionsGetRequest
 */
export interface EmailOptionsApiEmailOptionsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof EmailOptionsApiEmailOptionsGet
     */
    readonly organizationId?: number
}

/**
 * Request parameters for emailOptionsPost operation in EmailOptionsApi.
 * @export
 * @interface EmailOptionsApiEmailOptionsPostRequest
 */
export interface EmailOptionsApiEmailOptionsPostRequest {
    /**
     * 
     * @type {CreateNewEmailOptionsCommand}
     * @memberof EmailOptionsApiEmailOptionsPost
     */
    readonly createNewEmailOptionsCommand?: CreateNewEmailOptionsCommand
}

/**
 * Request parameters for emailOptionsPut operation in EmailOptionsApi.
 * @export
 * @interface EmailOptionsApiEmailOptionsPutRequest
 */
export interface EmailOptionsApiEmailOptionsPutRequest {
    /**
     * 
     * @type {UpdateEmailOptionsCommand}
     * @memberof EmailOptionsApiEmailOptionsPut
     */
    readonly updateEmailOptionsCommand?: UpdateEmailOptionsCommand
}

/**
 * Request parameters for emailOptionsTestConnectionPost operation in EmailOptionsApi.
 * @export
 * @interface EmailOptionsApiEmailOptionsTestConnectionPostRequest
 */
export interface EmailOptionsApiEmailOptionsTestConnectionPostRequest {
    /**
     * 
     * @type {TestSmtpConnectionCommand}
     * @memberof EmailOptionsApiEmailOptionsTestConnectionPost
     */
    readonly testSmtpConnectionCommand?: TestSmtpConnectionCommand
}

/**
 * EmailOptionsApi - object-oriented interface
 * @export
 * @class EmailOptionsApi
 * @extends {BaseAPI}
 */
export class EmailOptionsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailOptionsApi
     */
    public emailOptionsActiveGet(options?: AxiosRequestConfig) {
        return EmailOptionsApiFp(this.configuration).emailOptionsActiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailOptionsApiEmailOptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailOptionsApi
     */
    public emailOptionsGet(requestParameters: EmailOptionsApiEmailOptionsGetRequest = {}, options?: AxiosRequestConfig) {
        return EmailOptionsApiFp(this.configuration).emailOptionsGet(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailOptionsApiEmailOptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailOptionsApi
     */
    public emailOptionsPost(requestParameters: EmailOptionsApiEmailOptionsPostRequest = {}, options?: AxiosRequestConfig) {
        return EmailOptionsApiFp(this.configuration).emailOptionsPost(requestParameters.createNewEmailOptionsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailOptionsApiEmailOptionsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailOptionsApi
     */
    public emailOptionsPut(requestParameters: EmailOptionsApiEmailOptionsPutRequest = {}, options?: AxiosRequestConfig) {
        return EmailOptionsApiFp(this.configuration).emailOptionsPut(requestParameters.updateEmailOptionsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailOptionsApiEmailOptionsTestConnectionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailOptionsApi
     */
    public emailOptionsTestConnectionPost(requestParameters: EmailOptionsApiEmailOptionsTestConnectionPostRequest = {}, options?: AxiosRequestConfig) {
        return EmailOptionsApiFp(this.configuration).emailOptionsTestConnectionPost(requestParameters.testSmtpConnectionCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
